import {LocalizationProvider, MobileTimePicker} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import React, {useEffect, useState} from "react";
import dayjs from "dayjs";

export default function DHTimePicker({label, value, changeValue, disabled}) {

    const [myValue, setMyValue] = useState(null);

    useEffect(() => {
        if (value === undefined) {
            setMyValue(undefined);
            return;
        }
        setMyValue(dayjs("2025-01-01T" + value));
    }, [value]);

    return <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"de"}>
        <MobileTimePicker label={label}
                          value={myValue}
                          onError={(e) => {
                              if (e) {
                                  changeValue(undefined);
                              }
                          }}
                          onChange={(e) => {
                              if (e) {
                                  let formattedValue = e.format('HH:mm');
                                  changeValue(formattedValue);
                              } else {
                                  changeValue(undefined);
                              }
                          }}
                          slotProps={{
                              actionBar: {
                                  actions: ['accept', 'clear', 'cancel']
                              },
                              textField: {size: 'small', placeholder: ''}
                          }}
                          disabled={disabled}
        />
    </LocalizationProvider>
}